import { ROLE_TYPE } from "@supplier/meta";
import Layout from "@/views/layouts/index.vue";
import { UserStore } from "@/stores/user";
import tradeContractRouters from "@/routers/tradeManagement/contractManagement";
import tradeReconciliationRouters from "@/routers/tradeManagement/reconciliation";
import { hasTradePermission } from "@/utils/permission";
import { AccountStore } from "@/stores/account";

export const tradeManagementRouters = [
    {
        path: "/tradeManagement",
        name: "TradeManagement",
        component: Layout,
        redirect: "/tradeManagement/tradeContract",
        meta: {
            title: "贸易业务",
            icon: "icon-maoyiyewu",
            hidden: ({ userStore, accountStore }: { userStore: UserStore; accountStore: AccountStore }) => {
                // SAAS 环境下隐藏
                if (userStore.isSAAS) {
                    return true;
                }
                if (accountStore.isSubAccount) {
                    return !hasTradePermission(userStore.userInfo.permissions);
                }
                // 如果 roles 中没有 ROLE_TYPE.TRADE_CUSTOMER，也隐藏
                return !userStore.userInfo?.customer?.roles?.includes(ROLE_TYPE.TRADE_CUSTOMER.code);
            }
        },
        children: [...tradeContractRouters, ...tradeReconciliationRouters]
    }
];
